import React from "react";

export const PageHeader = ({ overline, title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-9">
    <div className="animate-fade-up">
      {overline && <p className="text-[0.62rem] uppercase tracking-[0.25em] text-gold mb-2">{overline}</p>}
      <h1 className="text-3xl sm:text-4xl tracking-tight text-navy">{title}</h1>
      {subtitle && <p className="text-navy/50 text-sm mt-2 max-w-lg">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Spinner = ({ className = "h-5 w-5", color = "#C9A84C" }) => (
  <svg className={`animate-spin ${className}`} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={color} strokeOpacity="0.25" strokeWidth="3" />
    <path d="M22 12a10 10 0 0 0-10-10" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const CategoryBadge = ({ label }) => (
  <span className="text-[0.6rem] uppercase tracking-[0.18em] text-navy/60 bg-navy/5 rounded-full px-2.5 py-1">{label}</span>
);
